var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/camelcase */
import * as Sentry from '@sentry/react';
import { v4 as uuidv4 } from 'uuid';
import { ILogger } from '../types';
// TODO get rid of it
// Old severity from v5 to v8
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "fatal";
})(Severity || (Severity = {}));
var SentryLogger = /** @class */ (function (_super) {
    __extends(SentryLogger, _super);
    function SentryLogger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initialized = false;
        _this.init = function (params) {
            Sentry.init(params);
            _this.release = params.release;
            _this.initialized = true;
        };
        _this.sendEvent = function (_a) {
            var message = _a.message, tags = _a.tags, responseData = _a.responseData, level = _a.level, request = _a.request, extra = _a.extra;
            if (!_this.initialized) {
                return;
            }
            var severityLevel = level
                ? Severity[level] || Severity.Error
                : Severity.Error;
            Sentry.captureEvent({
                event_id: uuidv4(),
                message: message,
                release: _this.release,
                level: severityLevel,
                tags: tags,
                extra: __assign(__assign({}, extra), { response: JSON.stringify(responseData, null, 2), origin: window.origin }),
                request: request,
            });
        };
        _this.sendError = function (_a) {
            var project = _a.project, message = _a.message, error = _a.error;
            if (error instanceof Error) {
                _this.sendEvent({
                    message: "@" + project + "/" + message,
                    level: 'Error',
                    extra: {
                        error: error,
                    },
                });
                return;
            }
            if (typeof error === 'string') {
                _this.sendEvent({
                    message: "@" + project + "/" + error,
                    level: 'Error',
                    extra: {
                        error: error,
                    },
                });
            }
        };
        return _this;
    }
    return SentryLogger;
}(ILogger));
export { SentryLogger };
